import {
  EventAdapterInteface,
  ListEventsInput,
} from 'src/adapter/EventAdapterInterface';
import { EventModelAttributes } from 'src/models/EventModel';
import { NotFoundException, Exception } from 'src/exceptions';
import { Events } from 'src/mock/events';
export class MockEventAdapter implements EventAdapterInteface {
  listEvents(
    conditions: ListEventsInput
  ): Promise<{ total: number; events: EventModelAttributes[] }> {
    return new Promise(function (resolve) {
      setTimeout(() => {
        try {
          let res = { total: 0, events: [] };
          const events = Events;
          const start = conditions.page * conditions.limit - conditions.limit;
          const end = start + conditions.limit;
          const newEvents = events.slice(start, end);
          res = {
            total: events.length,
            events: newEvents,
          };
          resolve(res);
        } catch (e) {
          throw new Exception();
        }
      }, 1000);
    });
  }
  getEvent(id: string): Promise<EventModelAttributes> {
    return new Promise(function (resolve) {
      setTimeout(() => {
        try {
          const events = Events;
          const res = events.find((item: { id: string }) => item.id == id);
          if (!res) throw new NotFoundException();
          resolve(res);
        } catch (e) {
          throw new Exception();
        }
      }, 1000);
    });
  }
}
